import { render, staticRenderFns } from "./DataListTeams_validate.vue?vue&type=template&id=3f80647d&scoped=true&"
import script from "./DataListTeams_validate.vue?vue&type=script&lang=js&"
export * from "./DataListTeams_validate.vue?vue&type=script&lang=js&"
import style0 from "./DataListTeams_validate.vue?vue&type=style&index=0&id=3f80647d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f80647d",
  null
  
)

export default component.exports